import { IAction, ActionOrigin, ActionType } from '../actions/index';


export function browserNavigated(state: boolean, action: IAction) {
    // If origin is specified, use that
    if (typeof action.origin !== 'undefined') {
        return action.origin === ActionOrigin.BROWSER_NAVIGATION;
    }

    // Otherwise check if action was a browser navigation
    return action.type === ActionType.BROWSER_NAVIGATION;
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/reducers/browser-navigated.ts